import "./css/info.css"
import logo from '../../src/agri.png';
import { Link } from "react-router-dom";


export default function InfoHaveNotSub({ user }) {

	const signout = () => {
		localStorage.setItem("token", null)
	}

	return (
		<>
			<nav className="navbar navbar-expand-lg fixed-top">
				<div className="container d-flex justify-content-center">
					<Link className="navbar-brand" to={'/sign-in'}>
					</Link>
				</div>
				<div className="container d-flex justify-content-center">
					<Link className="navbar-brand" to={'/sign-in'}>
						<img src={logo} class='radius-img' alt="Logo" width={100} height={80} />
					</Link>
				</div>
				<div className="container d-flex justify-content-center">
					<Link className="navbar-brand" to={'/sign-in'}>
						<button type="button" onClick={signout()} class="btn btn-outline-success">Sign out</button>
					</Link>
				</div>
			</nav>
			<br></br>
			<br></br>
			<br></br>

			<div className="auth-wrapper">
				<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" />
				<header class="masthead text-center back-image">
					<div class="">
						<div class="">
							<div class="">
								<h1 class="mb-4">You dont have an active subscription!!</h1>
							</div>
						</div>
					</div>
				</header>
				<div class="pricing-area">
  <div class="">
    <div class="row justify-content-center">
      <div class="col-md-4 col-sm-6 col-xs-12">
        <div class="single-price">
          <div class="deal-top">
            <h3>Basic</h3>
            <h4> 9.99 <span class="sup">€</span> </h4> 
          </div>
          <div class="deal-bottom">
            <ul class="deal-item">
              
            </ul>
            <div class="btn-area">
              <a href={process.env.REACT_APP_PAY + "pay?username="+localStorage.getItem("email")+"&plan=monthly-subscription"}>Purchase</a>       
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12">
        <div class="single-price">
          <div class="deal-top">
            <h3>Standard</h3>
            <h4> 99.99 <span class="sup">€</span> </h4>
          </div>
          <div class="deal-bottom">
            <ul class="deal-item">
              
            </ul>
            <div class="btn-area">
			<a href={process.env.REACT_APP_PAY + "pay?username="+localStorage.getItem("email")+"&plan=annual-subscription"}>Purchase</a>       
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>       


</div>


			</div>

		</>
	)
}